export const PROPERTY_API_PATH = "/api/Properties/";
export const UTILITY_API_PATH = "/api/Utility/";
export const EXPENSE_API_PATH = "/api/Expense/";
export const HOA_API_PATH = "/api/HOAPolicy/";
export const STRIPE_API_PATH = "/api/Stripe/";
export const LEASE_API_PATH = "/api/Lease/";
export const CALENDAR_API_PATH = "/api/CalendarEvents/";
export const NOTICE_API_PATH = "/api/NoticeEvent/";
export const USER_GRAPH_URL = "https://graph.microsoft.com/v1.0/me";